import { Loader, IconButton } from 'components/Blocks';

import { DownloadIcon } from 'components/Icons';

import { actions } from 'entities';

interface DownloadFileButtonProps {
  children?: never;
  url: string;
  name: string;
  filename?: string;
  className?: string;
  size?: number;
}

export function DownloadFileButton({
  url,
  name,
  className,
  size,
  filename,
}: DownloadFileButtonProps) {
  const download = actions.uploads.downloadFile.use({
    params: {
      name: filename || name,
      url,
    },
  });

  return (
    <IconButton
      size="small"
      onClick={download.onClick}
      tooltipContent="Download"
      className={className}
    >
      {download.loading ? <Loader type="atom" size={size} /> : <DownloadIcon size={size} />}
    </IconButton>
  );
}
